// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3f789411","977":"ffe1f048"}[chunkId] + ".chunk.js";
};